import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {
  StatementImportItem,
} from "@model";
import {AccountStatementsService} from "@services";
import {inject} from "@angular/core";

export const AccountStatementItemListReslover: ResolveFn<Observable<StatementImportItem[]>|StatementImportItem[]> = (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  accountStatementsService: AccountStatementsService = inject(AccountStatementsService)
  ): Observable<StatementImportItem[]>|StatementImportItem[] => {
    return accountStatementsService.findImportItems(+route.queryParams['importId'])
};
